import React, { useEffect, useRef, useState } from 'react';
import ModulNavigation from './ModulNavigation'; 
import ModulBasket from './ModulBasket'; 
import '../assets/Checkout.css';
import '../assets/compatibility/Amazon-pay.css';
import '../assets/compatibility/Request-buttons.css';
import '../assets/Checkout-sidecart.css';

function ModulCheckout({store}) {
  const basketRef = useRef(null);
  const [isSticky, setIsSticky] = useState(false);
  console.log("Store in checkout: ", store.getState());

  useEffect(() => {
    console.log("ModulCheckout mounted");
    return () => {
      console.log("ModulCheckout unmounted");
    };
  }, []);


  useEffect(() => {
    const handleScroll = () => {
      if (basketRef.current) {
        const basketTop = basketRef.current.getBoundingClientRect().top;
        setIsSticky(basketTop <= 0); // Aktiviert sticky, wenn der obere Rand erreicht wird
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);


  return (
    <div>
      <div className="woocommerce-order">
        <div className="bootstrap-ips container mt-1 mb-0" data-bs-theme="ips-light">
          <div className="row p-2 mx-0 woo-header-set">
            <div className="ips-checkout-baseleft pe-4 col-md-8 col-sm-12 pe-2">
              <ModulNavigation store={store} />
            </div>
            <div
              className={`ips-basket-baseright col-md-4 col-sm-12  sticky-top ${isSticky ? 'sticky-ips-custom pt-4' : 'p-0 pt-0'}`} // sticky-top hier
              ref={basketRef}
            >
              <ModulBasket store={store} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ModulCheckout;